import { Box, Typography } from '@mui/material';
import CustomButton from '../../Components/Button/CustomButton';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
    const navigate = useNavigate();
  return (
   <div>
    <Box sx={{display: 'flex',flexDirection:"column", justifyContent: 'center', alignItems: 'center', height: '100vh',background: "backgroundTab.main"}}>
  <Typography sx={{color:"red", fontSize:"102px"}}>
    404
  </Typography>
  <Typography sx={{color:"#3F3F40", fontSize:"22px", fontWeight:"bold",margin:"10px"}}>
   Page not found !
  </Typography>
  <Typography sx={{color:"#5F5E5B", fontSize:"14px", fontWeight:"400",margin:"10px"}}>
  oops the page you are looking for does not exist !
  </Typography>
  <CustomButton
   variant='secondary'
   name="Back To Home"
   onClick={()=>navigate("/")}/>
    </Box>
   </div>
  )
}

export default ErrorPage
